module.exports = __webpack_public_path__ + "img/dashboard.5c81d7c0.png";